import React from 'react';
import { DropDown } from './common';
import {DuLieuHeThong} from 'api';

class DropDownKetQuaGiaiQuyetDon extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      selectedValue: this.props.selectedValue,
      data: []
    }
  }

  componentDidMount() {
    this.getKetQuaGiaiQuyetDon();
  }

  onChange(e) {
    this.props.onChange(e);
  }

  getKetQuaGiaiQuyetDon() {
    let params = {
      khongCoDoiThoai: false,
      loaiDon: this.props.loaiDon
    }
    DuLieuHeThong.actions.getKetQuaGiaiQuyetDon.request(params).then(res => {
      if (res.data) {
        if (this.props.isTTXMLai) {
          res.data = res.data.filter(item => {
            return item.giaTri != 'GIAO_THAM_TRA_XAC_MINH_LAI'
          });
        }
        this.setState({data: res.data});
      }
    })
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isTTXMLai) {
      let newData = this.state.data.filter(item => {
        return item.giaTri != 'GIAO_THAM_TRA_XAC_MINH_LAI'
      });
      this.setState({data: newData});
    }
    this.setState({
      selectedValue: nextProps.selectedValue
    });
  }

  render() {
    return (
      <DropDown label='' disabled={this.props.disable} confirm={this.props.confirm} selectedValue={this.state.selectedValue} options={ this.state.data } keyName='giaTri' valueName='ten' className={this.props.className} onChange={ this.onChange.bind(this) } placeholder={ this.props.placeholder } name={this.props.name}/>
    );
  }
}

DropDownKetQuaGiaiQuyetDon.defaultProps = {
  onChange: function() {
    console.log('Need to assign onChange method');
  },
  disable: false,
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  options: [],
  selectedValue: '',
  confirm: false,
  name: '',
  isTTXMLai: false,
  loaiDon: ''
}

export default DropDownKetQuaGiaiQuyetDon;


// WEBPACK FOOTER //
// ./src/components/tt-forms/dropdown-ketquagiaiquyetdon.jsx